import React from "react";
import { Container, Typography } from "@material-ui/core";
import NewsletterTable from "./NewsletterTable.js";
import FollowUpTable from "./FollowUpTable.js";

export default props => {
    props.setLocationName();
    return (
        <Container maxWidth="lg">
            <NewsletterTable />
            <div style={{ margin: "30px 0 20px 0" }}>
                <Typography variant="h4" gutterBottom>
                    Opfølgningsbesked
                </Typography>
            </div>
            <FollowUpTable />
        </Container>
    );
};
